import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IonicModule, Platform } from '@ionic/angular';
import { KeycloakService } from 'keycloak-angular';
import { forbrukRoute, forsideRoute } from '../routes';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-broker',
  templateUrl: './broker.page.html',
  standalone: true,
  imports: [CommonModule, IonicModule]
})
export class BrokerPage implements OnInit {
  isLoggedIn: boolean;
  hasLoggedOut: boolean = false;

  constructor(
    private _keycloakService: KeycloakService,
    private route: ActivatedRoute,
    private router: Router,
    private platform: Platform
  ) {}

  async doRefresh() {
    setTimeout(function () {
      window.location.reload();
    }, 1000);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(async (params) => {
      this.isLoggedIn = this._keycloakService.isLoggedIn();
      if (params['Action'] && params['Action'].toLowerCase() == 'logout') {
        if (this.isLoggedIn) {
          if (this.platform.is('capacitor')) {
            this.doRefresh();
            this.hasLoggedOut = true;
          }
          await this._keycloakService.logout();
        } else {
          this.router.navigate([forsideRoute]);
        }
      } else {
        if (!this.isLoggedIn) this.router.navigate([forsideRoute]);
        else this.router.navigate([forbrukRoute]);
      }
    });
  }

  goToLogin() {
    this.router.navigate([forsideRoute]);
  }
}
